var map = {
	"./a-area-picker-form/style/index.tsx": "./components/a-area-picker-form/style/index.tsx",
	"./a-area-picker/style/index.tsx": "./components/a-area-picker/style/index.tsx",
	"./a-calendar-form/style/index.tsx": "./components/a-calendar-form/style/index.tsx",
	"./a-choose-modal/style/index.tsx": "./components/a-choose-modal/style/index.tsx",
	"./a-form-field/style/index.tsx": "./components/a-form-field/style/index.tsx",
	"./a-image-picker/style/index.tsx": "./components/a-image-picker/style/index.tsx",
	"./a-multy-form-modal/style/index.tsx": "./components/a-multy-form-modal/style/index.tsx",
	"./a-switch-item/style/index.tsx": "./components/a-switch-item/style/index.tsx",
	"./a-text-area/style/index.tsx": "./components/a-text-area/style/index.tsx",
	"./accordion/style/index.tsx": "./components/accordion/style/index.tsx",
	"./action-sheet/style/index.tsx": "./components/action-sheet/style/index.tsx",
	"./activity-indicator/style/index.tsx": "./components/activity-indicator/style/index.tsx",
	"./badge/style/index.tsx": "./components/badge/style/index.tsx",
	"./button/style/index.tsx": "./components/button/style/index.tsx",
	"./calendar/style/index.tsx": "./components/calendar/style/index.tsx",
	"./card/style/index.tsx": "./components/card/style/index.tsx",
	"./carousel/style/index.tsx": "./components/carousel/style/index.tsx",
	"./checkbox/style/index.tsx": "./components/checkbox/style/index.tsx",
	"./date-picker-view/style/index.tsx": "./components/date-picker-view/style/index.tsx",
	"./date-picker/style/index.tsx": "./components/date-picker/style/index.tsx",
	"./drawer/style/index.tsx": "./components/drawer/style/index.tsx",
	"./flex/style/index.tsx": "./components/flex/style/index.tsx",
	"./grid/style/index.tsx": "./components/grid/style/index.tsx",
	"./icon/style/index.tsx": "./components/icon/style/index.tsx",
	"./image-picker/style/index.tsx": "./components/image-picker/style/index.tsx",
	"./input-item/style/index.tsx": "./components/input-item/style/index.tsx",
	"./list-view/style/index.tsx": "./components/list-view/style/index.tsx",
	"./list/style/index.tsx": "./components/list/style/index.tsx",
	"./locale-provider/style/index.tsx": "./components/locale-provider/style/index.tsx",
	"./menu/style/index.tsx": "./components/menu/style/index.tsx",
	"./modal/style/index.tsx": "./components/modal/style/index.tsx",
	"./nav-bar/style/index.tsx": "./components/nav-bar/style/index.tsx",
	"./notice-bar/style/index.tsx": "./components/notice-bar/style/index.tsx",
	"./pagination/style/index.tsx": "./components/pagination/style/index.tsx",
	"./picker-view/style/index.tsx": "./components/picker-view/style/index.tsx",
	"./picker/style/index.tsx": "./components/picker/style/index.tsx",
	"./popover/style/index.tsx": "./components/popover/style/index.tsx",
	"./progress/style/index.tsx": "./components/progress/style/index.tsx",
	"./pull-to-refresh/style/index.tsx": "./components/pull-to-refresh/style/index.tsx",
	"./radio/style/index.tsx": "./components/radio/style/index.tsx",
	"./range/style/index.tsx": "./components/range/style/index.tsx",
	"./result/style/index.tsx": "./components/result/style/index.tsx",
	"./search-bar/style/index.tsx": "./components/search-bar/style/index.tsx",
	"./segmented-control/style/index.tsx": "./components/segmented-control/style/index.tsx",
	"./slider/style/index.tsx": "./components/slider/style/index.tsx",
	"./stepper/style/index.tsx": "./components/stepper/style/index.tsx",
	"./steps/style/index.tsx": "./components/steps/style/index.tsx",
	"./swipe-action/style/index.tsx": "./components/swipe-action/style/index.tsx",
	"./switch/style/index.tsx": "./components/switch/style/index.tsx",
	"./tab-bar/style/index.tsx": "./components/tab-bar/style/index.tsx",
	"./tabs/style/index.tsx": "./components/tabs/style/index.tsx",
	"./tag/style/index.tsx": "./components/tag/style/index.tsx",
	"./text/style/index.tsx": "./components/text/style/index.tsx",
	"./textarea-item/style/index.tsx": "./components/textarea-item/style/index.tsx",
	"./toast/style/index.tsx": "./components/toast/style/index.tsx",
	"./view/style/index.tsx": "./components/view/style/index.tsx",
	"./white-space/style/index.tsx": "./components/white-space/style/index.tsx",
	"./wing-blank/style/index.tsx": "./components/wing-blank/style/index.tsx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./components sync recursive ^\\.\\/[^_][\\w-]+\\/style\\/index\\.tsx?$";